import axiosCall from './interceptor';
import URL from '../helper';
import { saveByteArray, deepCopy } from '../javascript';
import { DESIGN_TYPE, COMPLEX_DOCUMENT_VERSION, DYNAMIC_TABLE_BLOCK } from '../complexDocumentConstants';
import { getIndexedDBData, putIndexedDBData } from '../indexedDBUtil';

export const createComplexDocument = async (payload, syncPayload = true) => {
  syncPayload && putIndexedDBData('complexDocument', payload);
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/document`;
  let response = await axiosCall('post', url,payload); 
  return response.data ;
}

export const getComplexDocument = async (id, version = COMPLEX_DOCUMENT_VERSION.DRAFT, userAction = true) => {
  let url = `${URL.DESIGN_SYSTEM_URL}dynamic/document/${id}`;
  if (version === COMPLEX_DOCUMENT_VERSION.QA_READY) {
    url = `${URL.TRANSACTION_SYSTEM_URL}qaReadyDocument?draftDocumentId=${id}&includeFlows=true`;
  } else if (version === COMPLEX_DOCUMENT_VERSION.PUBLISHED) {
    url = `${URL.TRANSACTION_SYSTEM_URL}publishedDocuments?draftDocumentId=${id}&includeFlows=true`;
  }
  let response = await axiosCall('get', url);
  if (version === COMPLEX_DOCUMENT_VERSION.DRAFT) {
    userAction && putIndexedDBData('complexDocument', response.data.data);
    return response.data;
  } else {
    console.log({ response });
    return {
      statusCode: response.data?.statusCode,
      data: response.data?.data[0]
    };
  }
}

export const getComplexDocumentStatus = async (id) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/documentTimestamp?draftDocumentId=${id}`;
  let response = await axiosCall('get', url);
  if (response?.data?.errors?.length === 0) {
    return {
      statusCode: response.data.statusCode,
      data: {
        draft: response.data?.data?.draft ? new Date(response.data.data.draft) : null,
        qaready: response.data?.data?.qaready ? new Date(response.data.data.qaready) : null,
        qacomplete: response.data?.data?.qacomplete
          ? new Date(response.data.data.qacomplete)
          : null,
        published: response.data?.data?.published ? new Date(response.data.data.published) : null,
      },
    };
  }
  return undefined;
}

export const getStandaloneFlowStatus = async (id) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/flowTimestamp?draftFlowId=${id}`;
  let response = await axiosCall('get', url);
  if (response.data.errors?.length === 0) {
    return {
      statusCode: response.data.statusCode,
      data: {
        draft: response.data.data.draft ? new Date(response.data.data.draft) : null,
        qaready: response.data.data.qaready ? new Date(response.data.data.qaready) : null,
        qacomplete: response.data.data.qacomplete ? new Date(response.data.data.qacomplete) : null,
        published: response.data.data.published ? new Date(response.data.data.published) : null
      }
    }
  }
  return undefined;
}

export const getStandaloneBlockStatus = async (id) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/blockTimestamp?draftBlockId=${id}`;
  let response = await axiosCall('get', url);
  if (response.data.errors?.length === 0) {
    return {
      statusCode: response.data.statusCode,
      data: {
        draft: response.data.data.draft ? new Date(response.data.data.draft) : null,
        qaready: response.data.data.qaready ? new Date(response.data.data.qaready) : null,
        qacomplete: response.data.data.qacomplete ? new Date(response.data.data.qacomplete) : null,
        published: response.data.data.published ? new Date(response.data.data.published) : null
      }
    }
  }
  return undefined;
}

export const sendToTesting = async (id, design = DESIGN_TYPE.DOCUMENT) => {
  let url = `${URL.DESIGN_SYSTEM_URL}dynamic/document/movetoqaready?id=${id}`;
  if (design === DESIGN_TYPE.FLOW) {
    url = `${URL.DESIGN_SYSTEM_URL}dynamic/flow/moveToQAReady?id=${id}`;
  } else if (design === DESIGN_TYPE.BLOCK) {
    url = `${URL.DESIGN_SYSTEM_URL}dynamic/moveBlockToQA?blockId=${id}`;
  }
  if (url !== '') {
    let response = await axiosCall('post', url);
    console.log({ response });
    return response.data;
  }
  return null;
}

export const moveToQaComplete = async (id, design = DESIGN_TYPE.DOCUMENT) => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}qaready/document?id=${id}&qareadystatus=qacomplete`;
  if (design === DESIGN_TYPE.FLOW) {
    url = `${URL.TRANSACTION_SYSTEM_URL}qaready/flow?id=${id}&qareadystatus=qacomplete`;
  } else if (design === DESIGN_TYPE.BLOCK) {
    url = `${URL.TRANSACTION_SYSTEM_URL}qaready/block?id=${id}&qaReadyStatus=qacomplete`;
  }
  if (url !== '') {
    let response = await axiosCall('patch', url);
    console.log({ response });
    return response.data;
  }
  return null;
}

export const publishDesign = async (id, design = DESIGN_TYPE.DOCUMENT) => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}document/publish?id=${id}`;
  if (design === DESIGN_TYPE.FLOW) {
    url = `${URL.TRANSACTION_SYSTEM_URL}flow/publish?id=${id}`;
  } else if (design === DESIGN_TYPE.BLOCK) {
    url = `${URL.TRANSACTION_SYSTEM_URL}block/publish?id=${id}`;
  }
  if (url !== '') {
    let response = await axiosCall('post', url);
    console.log({ response });
    return response.data;
  }
  return null;
}

export const generatePDF = async (payload, isPreview, isOpenDesign = false) => {
  console.log("generatePDF :: ", isPreview, isOpenDesign)
  let url = `${URL.TRANSACTION_SYSTEM_URL}print/complexdocument/${payload.documentDTO.documentId}`;
  if (isPreview) {
    if (isOpenDesign) {
      url = `${URL.TRANSACTION_SYSTEM_URL}print/open/preview/${payload.documentDTO.documentId}`;
    } else {
      url = `${URL.TRANSACTION_SYSTEM_URL}print/preview/${payload.documentDTO.documentId}`;
    }
  }
  payload.documentDTO.documentId = undefined;
  let response = await axiosCall('post', url, payload, true, false, true);
  if (response?.status === 200) {
    if(isPreview || isOpenDesign){
      return {status: response?.status, url: saveByteArray(payload.documentDTO.name, response.data, false)};
    } else{
      saveByteArray(payload.documentDTO.name, response.data);
    }
    return response;
  } else {
    return response;
  }
}

export const patchComplexDocument = async (payload, refrencedFlowId, callback, isInteractiveDesign = false, isOpenDesign = false, sync = true) => {

  const updateFlow= payload.flows||[].map(list => {
    if (list.isStandalone) {
      return {
        flowId: list.flowId,
        isStandalone: list.isStandalone,
        orderNumber: list.orderNumber,
        isDeleted: list?.isDeleted ? true : false,
        uuid :list?.uuid
      };
    }
    return list;
  });

  const newPayLoad = { ...payload, flows: updateFlow };

  let url = `${URL.DESIGN_SYSTEM_URL}dynamic/document/${payload.documentId}`;
  if (isInteractiveDesign) {
    // interactive design autosave url
    url = `${URL.DESIGN_SYSTEM_URL}interactiveDesign/${payload.documentId}`;
  } else if (isOpenDesign) {
    url = undefined;
  }
  let syncData = undefined;
  newPayLoad.documentId = undefined;
  if (url !== undefined) {
    let response = await axiosCall('put', url, newPayLoad, true, false);
    if (response?.data?.statusCode === 703 || response?.data?.statusCode === 5402) {
      syncData = response.data.data;
      syncData && callback && await callback(syncData);
    } else {
      console.log("Auto save unsuccessful!! ", response);
    }
  }
  if(!payload.flows && payload.documentName){
    payload.name = payload.documentName;
    payload.documentLevelChanges=true;
    delete payload.documentName;
  } else if (payload.summary) {
    payload.documentLevelChanges=true;
  }
  if (sync) {
    return syncToStorage(syncData, deepCopy(payload),refrencedFlowId, true, isOpenDesign);
  }
  return;
}

export const patchComplexFlow = async (payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/flow`;
  let syncData = undefined;
  let response = await axiosCall('put', url, { "flow": payload.flows[0] }, true, false);
  if(response?.data?.statusCode === 200) {
    response.data.data.flows = [response.data.data.flow];
    syncData = response.data.data;
  } else {
    console.log("Auto save unsuccessful!! ", response);
  }
  return syncToStorage(syncData, payload);
}

export const patchComplexBlock = async (payload, sync = true) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/block`;
  let syncData = undefined;
  let response = await axiosCall('put', url,
    { "parentBlockId": payload.documentId, "blocks": payload.flows[0].blocks, style:payload.flows[0].style }, true, false);
  if(response?.data?.statusCode === 2502) {
    response.data.data.flows = [{ "blocks": response.data.data }];
    syncData = response.data.data;
  } else {
    console.log("Auto save unsuccessful!! ", response);
  }
  if (sync) {
    return syncToStorage(syncData, payload, undefined, false);
  } else {
    return response;
  }
}


export const syncToStorage = async (syncData, payload,refrencedFlowUuid, documentFlow=true, isOpenDesign = false) => {
  const documentLevelChanges = payload.documentLevelChanges ?? false;
  delete payload.documentLevelChanges;
  const changes = JSON.parse(JSON.stringify(payload));
  const currentDocument = await getIndexedDBData(isOpenDesign ? 'openDocument' : 'complexDocument');
  delete changes.flows;
  console.log({ currentDocument, changes, syncData });
  const newDocument = Object.assign({}, currentDocument, changes);
  // Mimicking backend
  if (payload.flows && payload.flows.length > 0) {
    // Handle failure in API (payload grows bigger on every change)
    // 0. Clear out the flows that are not synced
    if (syncData === undefined) {
      newDocument.flows = newDocument.flows.filter((existingFlow) => existingFlow.flowId !== undefined);
    }
    // 1. Syncing changes in uuid or order number of existing flows
    newDocument.flows = newDocument.flows.map((existingFlow) => {
      const changesInFlow = payload.flows.findIndex(newFlow => newFlow.flowId === existingFlow.flowId);
      if (changesInFlow !== -1) {
        const newFlow = payload.flows[changesInFlow];
        const mergedFlow = Object.assign({}, existingFlow, {
          uuid: newFlow.uuid,
          orderNumber: newFlow.orderNumber,
          isDeleted: changesInFlow.isDeleted
        });
        if (newFlow.style) {
          mergedFlow.style = newFlow.style;
        }
        if (newFlow.paperSize) {
          mergedFlow.paperSize = newFlow.paperSize;
        }
        if (newFlow.paperOrientation) {
          mergedFlow.paperOrientation = newFlow.paperOrientation;
        }
        if (newFlow.header) {
          if (newFlow.header.blockId) {
            if (newFlow.header.isDeleted) { // TODO : Should change header and footer removal contract after discussion with backend
              mergedFlow.header = undefined;
            } else {
              mergedFlow.header = newFlow.header;
            }
          } else {
            mergedFlow.header = Object.assign({}, newFlow.header, {
              blockId: syncData ? syncData.flows[changesInFlow].header.blockId : undefined
            });
          }
        }
        if (newFlow.footer) {
          if (newFlow.footer.blockId) {
            if (newFlow.footer.isDeleted) { // TODO : Should change header and footer removal contract after discussion with backend
              mergedFlow.footer = undefined;
            } else {
              mergedFlow.footer = newFlow.footer;
            }
          } else {
            mergedFlow.footer = Object.assign({}, newFlow.footer, {
              blockId: syncData ? syncData.flows[changesInFlow].footer.blockId : undefined
            });
          }
        }
        if (newFlow.blocks?.length > 0) {
          // Handle failure in API (payload grows bigger on every change)
          // 0. Clear out the blocks that are not synced
          if (syncData === undefined) {
            // mergedFlow.blocks = existingFlow.blocks.filter(existingBlock => existingBlock.blockId !== undefined);
          } else {
            mergedFlow.blocks = [...existingFlow.blocks];
          }
          // 1. Syncing changes in uuid or order number of existing blocks
          mergedFlow.blocks = mergedFlow.blocks.map(existingBlock => {
            const changesInBlock = newFlow.blocks.findIndex(newBlock => newBlock.blockId === existingBlock.blockId
              || (syncData === undefined ? newBlock.uuid === existingBlock.uuid : false));
            if (changesInBlock !== -1) {
            try {
              const newBlock = newFlow.blocks[changesInBlock];
              const mergedBlock = Object.assign({}, existingBlock, {
                uuid: newBlock.uuid,
                orderNumber: newBlock.orderNumber,
                isDeleted: newBlock.isDeleted
              });
              if (newBlock.blockName) {
                mergedBlock.blockName = newBlock.blockName;
              }
              if (newBlock.style) {
                  mergedBlock.style = newBlock.style;
              }
              if (newBlock.contents) { // TODO : Check if there are more members to block
                mergedBlock.contents = newBlock.contents;
              }
              if (newBlock.variableContract) { // TODO : Check if there are more members to block
                mergedBlock.variableContract = newBlock.variableContract;
              }
              if (newBlock.blockDTOList) {
                // TODO: Check if blockDTOList is synced properly
                mergedBlock.blockDTOList = mergedBlock.blockDTOList || [];
                newBlock.blockDTOList.forEach(childBlock => {
                  const changesInBlock = syncData ? syncData.flows[changesInFlow].blocks.findIndex(syncBlock => newBlock.uuid === syncBlock.uuid) : -1;
                  const changesInChildBlock = mergedBlock.blockDTOList?.find(existingChildBlock => existingChildBlock.uuid === childBlock.uuid);
                  let childBlockLabel;
                  if (mergedBlock.blockType === DYNAMIC_TABLE_BLOCK) {
                    if (newBlock.style.tableProperties.topBlock === childBlock.uuid) {
                      childBlockLabel = 'topBlock';
                    } else if (newBlock.style.tableProperties.bottomBlock === childBlock.uuid) {
                      childBlockLabel = 'bottomBlock';
                    }
                  }
                  let newChildBlockId = changesInChildBlock?.blockId;
                  if (syncData && newChildBlockId === undefined) {
                    if (changesInBlock === -1) {
                      newChildBlockId = undefined
                    } else if (syncData.flows[changesInFlow].blocks[changesInBlock].blockDTOList) {
                      newChildBlockId = syncData.flows[changesInFlow].blocks[changesInBlock].blockDTOList.find(
                        syncedChildBlock => syncedChildBlock.uuid === childBlock.uuid)?.blockId;
                    }
                  }
                  if (changesInChildBlock === undefined) {
                    mergedBlock.blockDTOList.push(Object.assign({}, childBlock, {
                      blockId: newChildBlockId || childBlockLabel
                    }));
                  } else {
                    mergedBlock.blockDTOList = mergedBlock.blockDTOList.map(existingChildBlock => {
                      if (existingChildBlock.uuid === changesInChildBlock?.uuid) {
                        return Object.assign({}, childBlock, {
                          blockId: newChildBlockId || childBlockLabel
                        });
                      }
                      return existingChildBlock;
                    })
                  }
                  if (mergedBlock.blockType === DYNAMIC_TABLE_BLOCK && childBlockLabel) {
                    mergedBlock.style.tableProperties[childBlockLabel] = newChildBlockId || childBlockLabel;
                  }
                });
                console.log({ blockDTOList: mergedBlock });
              }
              return mergedBlock;
            } catch (err) {
              console.log("error in merging blocks :: ", err);
            }
            } else {
              return existingBlock;
            }
          });
          // 2. Removing the blocks that are deleted
          if (syncData && newFlow.blocks.filter(newBlock => newBlock.isDeleted).length > 0) {
            mergedFlow.blocks = mergedFlow.blocks.filter(existingBlock => {
              const changesInBlock = newFlow.blocks.findIndex(newBlock => newBlock.uuid === existingBlock.uuid);
              return changesInBlock === -1 || !newFlow.blocks[changesInBlock].isDeleted;
            });
          }
          // 3. Adding new blocks into the existing flow
          const newBlocks = newFlow.blocks.filter(newBlock => {
            if (newBlock.isDeleted) return false;
            if (syncData !== undefined && newBlock.blockId === undefined) return true;
            if (mergedFlow.blocks.findIndex(block => block.uuid === newBlock.uuid) === -1) return true;
            return false;
          });
          if (newBlocks.length > 0) {
            newBlocks.forEach(newBlock => {
              const changesInBlock = syncData ? syncData.flows[changesInFlow].blocks.findIndex(syncBlock => newBlock.uuid === syncBlock.uuid) : -1;
              if(newBlock.blockType === DYNAMIC_TABLE_BLOCK && newBlock.blockDTOList && newBlock.blockDTOList.length > 0){
                let blockMap = new Map();
                newBlock.blockDTOList.forEach(childBlock => {
                  const changesInChildBlock = syncData ? syncData.flows[changesInFlow].blocks[changesInBlock].blockDTOList.findIndex(syncChildBlock => childBlock.uuid === syncChildBlock.uuid) : -1;
                  const childBlockId = changesInChildBlock === -1 ? undefined : syncData.flows[changesInFlow].blocks[changesInBlock].blockDTOList[changesInChildBlock].blockId
                  childBlock.blockId = childBlockId
                  blockMap.set(childBlock.uuid, childBlockId);
                });
                newBlock.style = Object.assign({}, newBlock.style, {
                  tableProperties: Object.assign({}, newBlock.style.tableProperties, {
                    topBlock: newBlock.style.tableProperties.topBlock ? blockMap.get(newBlock.style.tableProperties.topBlock) : undefined,
                    bottomBlock: newBlock.style.tableProperties.bottomBlock ? blockMap.get(newBlock.style.tableProperties.bottomBlock) : undefined,
                  })
                })
              }
              mergedFlow.blocks = [...mergedFlow.blocks, Object.assign({}, newBlock, {
                blockId: changesInBlock === -1 ? undefined : syncData.flows[changesInFlow].blocks[changesInBlock].blockId
              })];
            });
          }
          // 4. Sort the blocks by order number
          mergedFlow.blocks.sort((a, b) => {
            if (a.orderNumber > b.orderNumber) {
              return 1;
            } else if (a.orderNumber < b.orderNumber) {
              return -1;
            }
            return 0;
          })
        }
        return mergedFlow;
      } else {
        return existingFlow;
      }
    });
    // 2. Removing the flows that are deleted
    if (syncData && payload.flows.filter(newFlow => newFlow.isDeleted).length > 0) {
      newDocument.flows = newDocument.flows.filter(existingFlow => {
        const changesInFlow = payload.flows.findIndex(newFlow => newFlow.uuid === existingFlow.uuid);
        return changesInFlow === -1 || !payload.flows[changesInFlow].isDeleted;
      });
    }
    // 3. Adding new flows into the existing document
    let newlyAddedFlows = payload.flows.filter(newFlow => newFlow.flowId === undefined);
    // Including newly added standalone flows which will have flowId
    if (documentFlow) {
      payload.flows.filter(newFlow => newFlow.isStandalone && !newFlow.isDeleted).forEach(standaloneFlow => {
        if (newDocument.flows.find(existingFlow => existingFlow.flowId === standaloneFlow.flowId) === undefined) {
          newlyAddedFlows.push(standaloneFlow);
        }
      })
    }
    if (documentFlow && newlyAddedFlows.length > 0) {
      newlyAddedFlows.forEach(newFlow => {
        let syncDataIndex = syncData?.flows ? syncData.flows.findIndex(syncFlow => syncFlow.uuid === newFlow.uuid) : -1;
        if (newFlow.isStandalone) {
          syncDataIndex = -1;
        }
        newDocument.flows = [...newDocument.flows, Object.assign({}, newFlow, {
          flowId: syncDataIndex === -1 ? newFlow?.flowId : syncData.flows[syncDataIndex].flowId,
          header: newFlow.header
            ? Object.assign({}, newFlow.header, {
                blockId: syncDataIndex === -1 ? newFlow.header?.blockId : syncData.flows[syncDataIndex].header.blockId
              })
            : undefined,
          footer: newFlow.footer
            ? Object.assign({}, newFlow.footer, {
                blockId: syncDataIndex === -1 ? newFlow.footer?.blockId : syncData.flows[syncDataIndex].footer.blockId
              })
            : undefined,
          blocks: newFlow.blocks?.map((block, blockIndex) => {
             let updatedBlock =  Object.assign({}, block, {
               blockId: syncDataIndex === -1 ? block?.blockId : syncData.flows[syncDataIndex].blocks[blockIndex].blockId
             });
             if(block.blockType === DYNAMIC_TABLE_BLOCK && block.blockDTOList && block.blockDTOList.length > 0 ){
              let blockMap = new Map();
              updatedBlock.blockDTOList.forEach((childBlock, childIndex) =>{
                childBlock.blockId = syncDataIndex === -1 ? childBlock?.blockId : syncData.flows[syncDataIndex].blocks[blockIndex].blockDTOList[childIndex].blockId;
                if (syncDataIndex === -1) {
                  blockMap.set(childBlock.blockId, childBlock.blockId);
                } else {
                  blockMap.set(childBlock.uuid, childBlock.blockId);
                }
              })
              updatedBlock.style.tableProperties.topBlock = updatedBlock.style.tableProperties.topBlock ? blockMap.get(updatedBlock.style.tableProperties.topBlock) : undefined;
              updatedBlock.style.tableProperties.bottomBlock = updatedBlock.style.tableProperties.bottomBlock ? blockMap.get(updatedBlock.style.tableProperties.bottomBlock) : undefined;
             }
             return updatedBlock;
           })
        })]
      })
    } 
    else {   
      // Referenced flow already has flowId, blockId, headerId, and footerId 
      // use payload data; there's no need to use syndata   
      if (refrencedFlowUuid !== undefined) {
        payload.flows.filter((newFlow, flowIndex) => refrencedFlowUuid.includes(newFlow.uuid)).forEach(newFlow => {
          const findIndex = newDocument.flows.find((eFlow) => eFlow.uuid === newFlow.uuid);
          if (!findIndex) {
            newDocument.flows = [...newDocument.flows, newFlow];
          }
        })
      }    
    }
    // 4. Sort the flows by order number
    newDocument.flows.sort((a, b) => {
      if (a.orderNumber > b.orderNumber) {
        return 1;
      } else if (a.orderNumber < b.orderNumber) {
        return -1;
      }
      return 0;
    })
  }
  if (documentLevelChanges) {
    if (payload.summary)
      newDocument.summary = Object.assign({}, payload.summary, {
        blockId: syncData?.summary?.blockId
      });
  }

  putIndexedDBData(isOpenDesign ? 'openDocument' : 'complexDocument', newDocument);
  // TODO : strip off block design in response - only flowIds and orderNumbers are needed
  // TODO : Inform backend team about maintaining the order of the request to correctly match the IDs and order number
  if(documentLevelChanges) syncData.documentLevelChanges= documentLevelChanges;
    return syncData;
}

export const updateResourceNames = async (data, isStandalone = false) => {
  const uriComponent = Object.keys(data).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`).join('&');
  const url = `${URL.DESIGN_SYSTEM_URL + (isStandalone ? 'standalone' : 'dynamic')}/name?${uriComponent}`;
  let response = await axiosCall('patch', url);
  return response.data;
}

export const updateCommunicationName = async (id, communicationName) => {
  const url = `${URL.DESIGN_SYSTEM_URL}channel/map?id=${id}&communicationName=${encodeURIComponent(communicationName)}`;
  let response = await axiosCall('post', url);
  return response.data;
}

export const templatesByGroup = async (data) => {
const url = `${URL.DESIGN_SYSTEM_URL}dynamic/document?groupId=${data}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const deleteComplexDocument = async (documentId) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/document?id=${documentId}`;
  let response = await axiosCall('delete', url);
  return response.data;
}

export const translateComplexDocument = async (data) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/translate?id=${data.documentId}&language=${data.languageCode}`;
  let response = await axiosCall('post', url);
  return response.data;
}

export const fetchManageTags = async (payload) => {
  const searchParam = new URLSearchParams(payload);
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/tags`;
  let response = await axiosCall('get', url,searchParam);
  return response.data;
}

export const updateTags = async (data) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/tags`;
  let response = await axiosCall('patch', url, data);
  return response.data;
}

// standalone Flow API's
export const createStandaloneFlow = async (payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/flow`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

// standalone Flow API's
export const getFlowByCategory = async (payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/flowByCategory?countPerCategory=${payload}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const fetchStandaloneFlow  = async (payload) => { 
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/flow`;
  let response = await axiosCall('get', url, payload);
  return response.data;
}

export const getStandaloneFlow = async (id,userAction,version = COMPLEX_DOCUMENT_VERSION.DRAFT) => {
  let url = `${URL.DESIGN_SYSTEM_URL}standalone/flow/${id}`;
  if (version === COMPLEX_DOCUMENT_VERSION.QA_READY) {
    url = `${URL.TRANSACTION_SYSTEM_URL}qaReadyFlow?draftFlowId=${id}&includeData=true`;
  } else if (version === COMPLEX_DOCUMENT_VERSION.PUBLISHED) {
    url = `${URL.TRANSACTION_SYSTEM_URL}publishedFlow?draftFlowId=${id}`;
  }
  let response = await axiosCall('get', url);
  if (version === COMPLEX_DOCUMENT_VERSION.DRAFT) {
    userAction && putIndexedDBData('complexDocument', response.data.data);
    return response.data;
  } else {   
    return {
      statusCode: response.data?.statusCode,
      data: response.data?.data[0]
    };
  }
}

export const getReusableFlow = async (id,userAction) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/getFlowById?id=${id}`;
  let response = await axiosCall('get', url);
  userAction && putIndexedDBData('complexDocument', response.data.data);
  return response.data;
}

export const getTocFlow = async (documentId) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/toc/refresh/${documentId}`;
  let response = await axiosCall('get', url, null, true, false);
  return response.data;
}

// Standalone Block API's
export const createStandaloneBlock = async (payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/block`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

export const fetchStandaloneBlock  = async (payload) => { 
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/block`;
  let response = await axiosCall('get', url, payload);
  return response.data;
}

export const getStandaloneBlock = async (id, version = COMPLEX_DOCUMENT_VERSION.DRAFT, updateSession = true) => {
  let url = `${URL.DESIGN_SYSTEM_URL}standalone/block/${id}`;
  if (version === COMPLEX_DOCUMENT_VERSION.QA_READY) {
    url = `${URL.TRANSACTION_SYSTEM_URL}qaReadyBlock?draftBlockId=${id}`;
  } else if (version === COMPLEX_DOCUMENT_VERSION.PUBLISHED) {
    url = `${URL.TRANSACTION_SYSTEM_URL}publishedBlock?draftBlockId=${id}`;
  }
  let response = await axiosCall('get', url);
  if (version === COMPLEX_DOCUMENT_VERSION.DRAFT) {
    updateSession && putIndexedDBData('complexDocument', response.data.data);
    return response.data;
  } else {
    let blockList;
    if (response.data?.statusCode === 2505) {
      blockList = { ...response.data?.data[0], blocks: response.data?.data[0].blockDTOList }
    } 
    return {
      statusCode: response.data?.statusCode,
      data: blockList
    };
  }
}

// deleteStandaloneBlock
export const deleteStandaloneFlow= async (id) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/flow?id=${id}`;
  let response = await axiosCall('delete', url);
  return response.data;
}

export const translateStandaloneFlow= async (data) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/flow/translate?id=${data.documentId}&language=${data.languageCode}`;
  let response = await axiosCall('post', url);
  return response.data;
}

export const getFlowByGroup= async (data) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/flow?groupId=${data}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const deleteTranslatedFlow = async (flowId) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/flow?id=${flowId}`;
  let response = await axiosCall('delete', url);
  return response.data;
}
export const translateStandaloneBlock= async (data) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/translate/block?id=${data.documentId}&language=${data.languageCode}`;
  let response = await axiosCall('post', url);
  return response.data;
}

export const getBlockByGroup= async (data) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/block?groupId=${data}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const deleteTranslatedBlock = async (blockId) => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/block?id=${blockId}`;
  let response = await axiosCall('delete', url);
  return response.data;
}

// Lock & Unlock API's
export const checkLockStatus = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}lockstatus`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

export const lockResource = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}lock`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

export const unlockResource = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}unlock`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

export const getAllBlockByCategories = async (payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL }standalone/blockByCategory?countPerCategory=${payload}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const getSelectedDocument = async data => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/document?ids=${data}&includeFlows=true`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getSelectedStandAloneFlow = async data => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/flow?ids=${data}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getSelectedStandAloneBlock = async data => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/block?ids=${data}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const changeLanguage = async (payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/changeLanguage`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

export const changePpi = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/changePPI`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}
  

export const getMasterDocumentByCategory = async cancelTokenSource => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/masterDocumentsByCategory?countPerCategory=4`;
  const response = await axiosCall('get', url, { cancelToken: cancelTokenSource?.token });
  return response.data;
};

export const updateDisplayName = async (id, displayNameDTO) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/displayName`;
  let response = await axiosCall('put', url, displayNameDTO);
  return response.data;
};
export const getMasterDocument = async (payload, openAPI = false) => {
  const params = new URLSearchParams(payload);
  let url = `${URL.DESIGN_SYSTEM_URL}dynamic/masterDocuments?${params}`;
  if(openAPI)
    url = `${URL.DESIGN_SYSTEM_URL}dynamic/openMasterDocuments?${params}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const releaseDesignbroadcast = async (payload,id) => {
  const params = new URLSearchParams(id);
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/document/broadcast?${params}`;
  const response = await axiosCall('post', url, payload);
  return response.data;
};

export const showDesignbroadcast = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/document/broadcast/display`;
  const response = await axiosCall('patch', url, payload);
  return response.data;
};

export const getMasterDocumentDisplayStatus = async documentId => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/masterDocuments/${documentId}/display`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getMasterlanguageList = async data => {
  const url = `${URL.BASE_URL}masterLanguages`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const postDataSetOverride = async (documentId, payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/dataSetOverride/${documentId}`;
  const response = await axiosCall('put', url, payload);
  return response.data;
};

export const checkCommunName = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}channel/name/check`;
  let response = await axiosCall('post', url, payload, null, false);
  return response.data;
};

export const generateAccessibilityScript = async (payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}text`;
  let response = await axiosCall('post', url, payload); 
  return response.data;
}

export const updateCloneable = async (id, isEditable) => {
  let url = `${URL.DESIGN_SYSTEM_URL}dynamic/editable/${id}?isEditable=${isEditable}`;
  let response = await axiosCall('patch', url);
  return response.data;
};
export const updateRenderingType = async (id, renderingType) => {
  let url = `${URL.DESIGN_SYSTEM_URL}dynamic/rendering-type/${id}?renderingType=${renderingType}`;
  let response = await axiosCall('patch', url);
  return response.data;
};
export const updateAccessible = async (id, isAccessible) => {
  let url = `${URL.DESIGN_SYSTEM_URL}dynamic/accessibility/${id}?accessibilityEnabled=${isAccessible}`;
  let response = await axiosCall('patch', url);
  return response.data;
};
export const saveTemplateDescription = async (payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/masterDocument/description`;
  const response = await axiosCall('post', url, payload);
  return response.data;
};
export const getTemplateDescription= async (documentId) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/masterDocument/description/${documentId}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const generatePayDownloadPDF = async (payload) => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}print/buyPDF/${payload.documentDTO.documentId}`;
  payload.documentDTO.documentId = undefined;
  let response = await axiosCall('post', url, payload, true, false, false);
  return response.data;
}

export const getWelcomeDocument = async () => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/welcomeDocument`;
  const response = await axiosCall('get', url);
  return response.data;
}